/*eslint-disable*/
import React from "react";
import Question from "../../components/faq/Question";
import { questions } from "./data";
import Navbar from "../../components/header/navbar";

const Faq = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <Navbar />
      <div className="w-full pb-4 sm:pb-10 md:pb-12 lg:pb-16 px-6 sm:pl-10 md:pl-12 lg:pl-16">
        <div className="pb-5 md:pb-10">
          <h2 className="text-oya-ghana-header-h3 md:text-oya-ghana-header-h2 font-medium">
            Frequently Asked Questions
          </h2>
          <p className="text-oya-ghana-header-h7 text-oya-ghana-ligth-dark">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Inventore
            voluptate aperiam ad cumque vitae molestiae alias sunt mollitia.
            Ipsa, perspiciatis!
          </p>
        </div>

        <div className="w-full">
          {questions.map((question, index) => (
            <div
              key={question.id}
              data-aos="fade-in"
              data-aos-duration="1500"
              data-aos-delaydata-aos-delay={`${index > 0 ? 200 * index : 0}`}
            >
              <Question
                title={question.title}
                answer={question.answer}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
